import React, { useState } from 'react'
import css from './Navbar.module.css'
import v from '../assets/v.png'

import {BiPhoneCall} from 'react-icons/bi'
import{BiMenuAltRight} from 'react-icons/bi'


const Navbar = () => {

  const[modal,setModal]=useState(false)
  return (
    // <div>Navbar</div>
    <>
    <div className={css.navbarbg}>
        <div className={css.firstsection}>
            {/* <img src={v}/> */}
            {/* <h2>|</h2> */}
            <p>Vinoth Kumar R</p>

        </div>
        <div  className={css.secondsection}>
            <ul>
                <a href='#home'>Profile</a>
                <a href='#skills'>Skills</a>
                <a href='#projects'>Projects</a>
                <a href='#experience'>Experience</a>
                <a href='#contact'>Contact</a>
                <a href='https://drive.google.com/file/d/1ftbdVavJFA032wMCULiwVXcetdOmGjbc/view' target='_blank'>Resume</a>
                <a>+91 9941698145 <span><BiPhoneCall/></span> </a>
            </ul>
        </div>
        <div className={css.thirdsection}>
          <p onClick={()=>{setModal(!modal)}}><BiMenuAltRight/></p>
        </div>
    </div>
    {modal ?<>
    <div className={css.modalbg}>
    <ul>
                <a onClick={()=>{setModal(!modal)}} href='#home'>Profile</a>
                <a onClick={()=>{setModal(!modal)}} href='#skills'>Skills</a>
                <a onClick={()=>{setModal(!modal)}} href='#projects'>Projects</a>
                <a onClick={()=>{setModal(!modal)}} href='#experience'>Experience</a>
                <a onClick={()=>{setModal(!modal)}} href='#contact'>Contact</a>
                <a onClick={()=>{setModal(!modal)}}  href='https://drive.google.com/file/d/1ftbdVavJFA032wMCULiwVXcetdOmGjbc/view' target='_blank' >Resume</a>
                <a>+91 9941698145 <span><BiPhoneCall/></span> </a>
            </ul>
    </div>
    </>:""}
    </>
  )
}

export default Navbar